import useQueue from './useQueue';
import mutationQueue from '../services/mutationQueue';

/**
 * Hook para acceder al estado de la cola de mutaciones offline
 *
 * @returns {Object} Estado de la cola de mutaciones
 */
function useMutationQueue() {
  return useQueue(mutationQueue);
}

export default useMutationQueue;
